<style lang="scss" scoped>
@import '@@/assets/css/global.scss';
</style>
<style lang="scss">
.gongdan_baogong {
  .el-form-item__label {
    font-size: 16px;
  }
  .el-input__inner {
    height: 38px;
    font-size: 16px;
  }
}
</style>
<template>
  <div v-loading="loading" class="gongdan_baogong">
    <el-popover ref="popover_qua" placement="bottom" trigger="focus"><keyboard type="phone" :str.sync="wo.shiftQty"></keyboard></el-popover>
    <el-popover ref="popover_unqua" placement="bottom" trigger="focus"><keyboard type="phone" :str.sync="wo.shiftUnqualitifiedQty"></keyboard></el-popover>

    <el-form v-if="wo" ref="form" :model="wo" label-width="120px" label-position="top" size="large">
      <el-form-item :label="$t('banci')" required>
        <el-select @change="change" v-model="wo.shift"><el-option v-for="shift in shifts" :label="shift.name" :value="shift.id"></el-option></el-select>
      </el-form-item>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('dangbanshuliang')" required><el-input v-popover:popover_qua v-model="wo.shiftQty" clearable="true"></el-input></el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('dangbanbuliangshu')" required><el-input v-popover:popover_unqua v-model="wo.shiftUnqualitifiedQty" clearable="true"></el-input></el-form-item>
        </el-col>
      </el-row>

      <el-form-item :label="$t('beizhu')"><el-input v-model="wo.reportRemark" type="textarea" clearable="true"></el-input></el-form-item>

      <el-form-item style="width: 100%;text-align: center;"
        ><el-button :loading="loading" style="width: 40%;height: 50px;" type="primary" @click="reportWo">{{ $t('baogong') }}</el-button></el-form-item
      >
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'gongdan_baogong',
  components: {},
  props: {
    wo: null
  },

  data() {
    return {
      loading: false,
      shifts: []
    };
  },

  computed: {
    woid() {
      return this.wo ? this.wo.id : null;
    }
  },
  watch: {
    woid: {
      handler(n, o) {
        this.shifts = [];
        this.listShifts();
      },
      immediate: true,
      deep: true
    }
  },
  created() {},
  mounted() {},
  beforeDestroy() {},

  methods: {
    keybord(e) {
      this.wo.shiftUnqualitifiedQty = this.wo.shiftUnqualitifiedQty + '1';
      e.preventDefault();
    },
    change(s) {
      this.shifts.forEach(s => {
        if (s.id == this.wo.shift) {
          this.getShiftQty(s);
        }
      });
    },
    listShifts() {
      this.loading = true;
      let params = {
        cellNo: this.wo.productionCellNo
      };
      this.http
        .post('/production/shift/listShiftByCustId?' + this.qs.stringify(params))
        .then(res => {
          //计算每一个班次的开始和结束时间戳
          for (var i = 0; i < res.length; i++) {
            let shift = res[i];

            let now = new Date();
            let btstr = shift['beginTime'].toString();
            let etstr = shift['endTime'].toString();
            let overday = shift['overDay'].toString();
            let bt = new Date(now.getFullYear() + '/' + String(now.getMonth() + 1).padStart(2, 0) + '/' + now.getDate() + ' ' + btstr);
            let et = 0;

            if (overday == '1') {
              //增加一天或者减少一天
              let newd = new Date((now.getTime() / 1000 - 86400) * 1000);
              //昨天
              bt = new Date(newd.getFullYear() + '/' + String(newd.getMonth() + 1).padStart(2, 0) + '/' + newd.getDate() + ' ' + btstr);
              //今天
              et = new Date(now.getFullYear() + '/' + String(now.getMonth() + 1).padStart(2, 0) + '/' + now.getDate() + ' ' + etstr);
              res[i].bt = bt;
              res[i].et = et;
              if (now >= bt && now <= et) {
                //设置当前班次
                this.$set(this.wo, 'shift', res[i].id);
                this.getShiftQty(res[i]);
              } else {
                bt = new Date(now.getFullYear() + '/' + String(now.getMonth() + 1).padStart(2, 0) + '/' + now.getDate() + ' ' + btstr);
                //明天
                newd = new Date((now.getTime() / 1000 + 86400) * 1000);
                et = new Date(newd.getFullYear() + '/' + String(newd.getMonth() + 1).padStart(2, 0) + '/' + newd.getDate() + ' ' + etstr);
                res[i].bt = bt;
                res[i].et = et;
                if (now >= bt && now <= et) {
                  //设置当前班次
                  this.$set(this.wo, 'shift', res[i].id);
                  this.getShiftQty(res[i]);
                }
              }
            } else {
              et = new Date(now.getFullYear() + '/' + String(now.getMonth() + 1).padStart(2, 0) + '/' + now.getDate() + ' ' + etstr);

              res[i].bt = bt;
              res[i].et = et;
              if (now >= bt && now <= et) {
                this.$set(this.wo, 'shift', res[i].id);
                this.getShiftQty(res[i]);
              }
            }
          }
          this.shifts = res;
        })
        .catch(err => {
          //联网失败的回调,隐藏下拉刷新的状态
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //获取当班产量以及不良数，每次切换班次都请求一次
    getShiftQty(shift) {
      this.loading = true;
      //报工接口需要主动上传班次的开始和结束时间
      this.$set(this.wo, 'beginTimeParam', shift.bt.getTime());
      this.$set(this.wo, 'endTimeParam', shift.et.getTime());

      let params = {
        no: this.wo.no
      };

      let getCurrentProduction = this.http.get('/production/wo/getCurrentProduction?' + this.qs.stringify(params));

      let params2 = {
        // shift.beginTime	是小时
        // shift.endTime 	是小时
        // 需要重新转时间戳,就是当前的时间戳,注意晚班是当前八点到第二天8点
        beginTime: shift.bt.getTime(),
        endTime: shift.et.getTime(),
        woNo: this.wo.no
      };

      let getShiftUnqualitifiedQty = this.http.get('/production/woqc/getShiftUnqualitifiedQty?' + this.qs.stringify(params2));

      Promise.all([getCurrentProduction, getShiftUnqualitifiedQty])
        .then(values => {
          this.$set(this.wo, 'shiftQty', values[0].shiftQty);
          //报工接口要同时提交【没有被手动修改的当班数，所以这里保留一下】
          this.$set(this.wo, 'machineQty', values[0].shiftQty);

          this.$set(this.wo, 'shiftUnqualitifiedQty', values[1].unqualitifiedQty);
        })
        .catch(err => {
          this.utils.errorMessage(err);
        })
        .finally(() => {
          this.loading = false;
        });

      // .then(res => {
      // 	this.$set(this.wo, 'shiftUnqualitifiedQty', res.unqualitifiedQty);
      // })
      // .catch(err => {
      // 	console.log(err);
      // });

      // .then(res => {
      // 	this.$set(this.wo, 'shiftQty', res.shiftQty);
      // 	//报工接口要同时提交【没有被手动修改的当班数，所以这里保留一下】
      // 	this.$set(this.wo, 'machineQty', res.shiftQty);
      // })
      // .catch(() => {});
    },
    reportWo() {
      if (this.shifts.length == 0) {
        this.utils.errorMessage(this.$t('qingxuanzebanci'));
        return;
      }

      if (this.wo.shiftQty <= 0) {
        this.$confirm(this.$t('dangqianbaogongdangbanshuwei0,shifoujixubaogong?'), this.$t('baogongqueren'), {
          confirmButtonText: this.$t('queding'),
          cancelButtonText: this.$t('quxiao'),
          type: 'warning'
        })
          .then(() => {
            this.cannotReport();
          })
          .catch(() => {});
      } else {
        this.cannotReport();
      }
    },
    cannotReport() {
      this.loading = true;
      this.http
        .post('/production/wo/cannotReport?' + this.qs.stringify(this.wo))
        .then(res => {
          if (res == null) {
            this.reportAction();
          } else {
            if (res.result == true) {
              this.$confirm('你在' + this.dayjs(res.reportDate).format('YYYY-MM-DD HH:mm:ss') + '已经报工,是否确定提交本次报工数据?', this.$t('baogongqueren'), {
                confirmButtonText: this.$t('queding'),
                cancelButtonText: this.$t('quxiao'),
                type: 'warning'
              })
                .then(() => {
                  this.reportAction();
                })
                .catch(() => {});
            } else {
              this.reportAction();
            }
          }
        })
        .catch(err => {
          this.utils.errorMessage(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    reportAction() {
      this.loading = true;
      this.http
        .post('/production/app/wo/reportWo', this.wo)
        .then(res => {
          this.listShifts();
          this.wo.reportRemark = '';
          this.$parent.$refs.gongdan_eq.refreshEq();
          this.utils.successMessage(this.$t('baogongchenggong'));
          if (res && res.code == 201) {
            this.$alert(res.msg, 'baogong', {
              confirmButtonText: 'zhidaole',
              callback: action => {
                this.$parent.getGongdan();
              }
            });
          }
        })
        .catch(err => {
          this.utils.errorMessage(err);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
